import { render } from "./catalogList.vue?vue&type=template&id=19fb391f&scoped=true"
import script from "./catalogList.vue?vue&type=script&lang=js"
export * from "./catalogList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19fb391f"]])

export default __exports__